import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RetailStoreFormWrapperComponent } from '../components/retail-store-form-wrapper/retail-store-form-wrapper.component';
import { 
  RetailStoreFormConfig,
  RETAIL_STORE_FORM_CONFIG
} from '../retail-store.config';

@Component({
  selector: 'app-retail-store-view',
  standalone: true,
  imports: [RetailStoreFormWrapperComponent],
  templateUrl: './retail-store-view.component.html',
  styleUrls: ['./retail-store-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RetailStoreViewComponent {
  config: RetailStoreFormConfig = {
    title: 'retailStore.form.view_physical_store',
    formFields: RETAIL_STORE_FORM_CONFIG.formFields,
    headerActions: RETAIL_STORE_FORM_CONFIG.headerActions,
    listRoute: '/channel/retail-store'
  };
}